import { Navigate } from "react-router-dom";

export default function RootRedirect() {
  const hostname = window.location.hostname;
  const subDomain = hostname.split(".");

  if (subDomain.length >= 3) {
    return <Navigate to="/auth/sign_in" />;
  }
  return <Navigate to="/accounts/go" />;
}
